module.exports = new Promise(resolve => {
    import(/* webpackIgnore: true */ 'https://app-conversational-ai-interface-mfe.app-dev.connectcdk.com/assets/remoteEntry.js').then(remote => {
        resolve({
            get: (r) => remote.get(r),
            init: (s) => { try { return remote.init(s) } catch (e) { console.error('[Aiva] remote init failed', e) } }
        })
    })
});